import React, {FC} from 'react';
import styled from 'styled-components';

import {MessageViewerVisitorUrlPopover} from './messageViewerVisitorUrlPopover';

/*
 * Props.
 */

export interface MessageViewerVisitorUrlProps {
  url?: string;
}

/*
 * Style.
 */

const StyledVisitorUrlDiv = styled.div`
  grid-area: visitor;
`;

/*
 * Component.
 */

export const MessageViewerVisitorUrl: FC<MessageViewerVisitorUrlProps> = (props) => {
  const {url} = props;

  return (
    <StyledVisitorUrlDiv>
      <MessageViewerVisitorUrlPopover url={url} />
    </StyledVisitorUrlDiv>
  );
};
